import { DownloadIcon, WarningIcon } from "@chakra-ui/icons";
import { Box, List, ListItem, Text, useDisclosure } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaButton, RanaModal } from "@nens/ranalib";

interface ModelCheckerErrorsProps {
  errors: string[];
  downloadTask?: () => void;
}

export function ModelCheckerErrors({ errors, downloadTask }: ModelCheckerErrorsProps) {
  const intl = useIntl();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box mt={2}>
      <RanaButton size="sm" onClick={onOpen} variant="danger" leftIcon={<DownloadIcon />}>
        <FormattedMessage
          id="revision.view_modelchecker_errors"
          defaultMessage="View modelchecker errors"
        />
      </RanaButton>
      <RanaModal
        isOpen={isOpen}
        onClose={onClose}
        topBar={intl.formatMessage({
          id: "revision.modelchecker_errors",
          defaultMessage: "Modelchecker errors",
        })}
      >
        <p>
          <WarningIcon color="semantic.error.main" boxSize={6} />{" "}
          <FormattedMessage
            id="revision.error_count"
            defaultMessage="There are <strong>{count} errors</strong>"
            values={{
              count: errors.length,
              strong: (chunks) => (
                <Text as="strong" color="semantic.error.main" display="inline">
                  {chunks}
                </Text>
              ),
            }}
          />
        </p>
        <List styleType="none" spacing={4} mt={2}>
          {errors.map((error, index) => (
            <ListItem key={error + index}>{error}</ListItem>
          ))}
        </List>
        <Box my={4} display="flex" justifyContent="flex-end" gap={4}>
          <RanaButton onClick={onClose} variant="tertiary">
            <FormattedMessage id="button.close" defaultMessage="Close" />
          </RanaButton>
          {downloadTask && (
            <RanaButton leftIcon={<DownloadIcon />} variant="primary" onClick={downloadTask}>
              <FormattedMessage
                id="revision.download_task_json"
                defaultMessage="Download task JSON"
              />
            </RanaButton>
          )}
        </Box>
      </RanaModal>
    </Box>
  );
}
